export default __webpack_public_path__ + "static/media/total.aa874c00.png";